// extracted by mini-css-extract-plugin
export var breadcrumb = "_12-2";
export var breadcrumbArrow = "_12-3";
export var breadcrumbs = "_12-0";
export var link = "_12-4";
export var small = "_12-1";